import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { VisualizadorPdfComponentDialog } from '../visualizador-pdf-dialog/visualizador-pdf-dialog.component';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { WebcamDialogComponent } from '../webcam-dialog/webcam-dialog.component';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorImgDialogComponent } from '../visualizador-img-dialog/visualizador-img-dialog.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-visualizador-plan-protection-dialog',
  templateUrl: './visualizador-plan-protection-dialog.component.html',
  styleUrl: './visualizador-plan-protection-dialog.component.scss'
})
export class VisualizadorPlanProtectionDialogComponent {

  step = 1
  validEmail = false
  planProtectionDetail: any = null;
  planProtectionForm: FormGroup
  ppVigente = false
  model
  editMode = true
  errorValidarCorreo = false
  headerTitle = 'Datos de Proveedor'
  gallery = {
    all: false,
    group1: true,
    group2: false,
    group3: false,
    group4: false
  };
  planProtection: any
  years = []
  modelos = []
  yearDisabled = true
  modelDisabled = true
  tieneFirma = false
  errorsModel = {
    folio: false,
    empresa: false,
    sucursal: false,
    ordenVenta: false,
    fechaContratado: false,
    fechaVigencia: false,
    nombreCliente: false,
    apellidosCliente: false,
    correoCliente: false,
    celularCliente: false,
    marca: false,
    modelo: false,
    ano: false,
    kilometraje: false,
    placas: false,
    noSerie: false,
    sku: false,
    descripcion: false,
  }
  contratoUrl = ''
  imagenes = []
  isDesktop
  section: any = 'general'
  redimidos = [
    1,
    2,
    3
  ]

  show(groupName) {
    this.gallery.all = (groupName == 'all') ? true : false;
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
    this.gallery.group4 = (groupName == 'group4') ? true : false;
  }

  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private router: Router,
    private ppService: PlanProtectionService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<VisualizadorPlanProtectionDialogComponent>) {

      const ua = navigator.userAgent;
      if (/mobile/i.test(ua)) {
        this.isDesktop = false;
      } else if (/tablet/i.test(ua)) {
        this.isDesktop = false;
      } else {
        this.isDesktop = true;
      }
      this.planProtection = data.planProtection
      this.getDetallePP()
      this.planProtectionForm = this.fb.group({
        folio: [{value: '', disabled: true}, [Validators.required]],
        empresa: [{value: '', disabled: true}, [Validators.required]],
        sucursal: [{value: '', disabled: true}, Validators.required],
        ordenVenta: [{value: '', disabled: true}, [Validators.required]],
        fechaContratado: [{value: '', disabled: true}, [Validators.required]],
        fechaVigencia: [{value: '', disabled: true}, [Validators.required]],
        nombreCliente: [{value: '', disabled: true}, [Validators.required]],
        apellidosCliente: [{value: '', disabled: true}, [Validators.required]],
        correoCliente: [{value: '', disabled: true}, [Validators.required]],
        celularCliente: [{value: '', disabled: true}, [Validators.required]],
        noCliente: [{value: 'data.clienteId', disabled: true}, [Validators.required]],
        marca: [{value: '', disabled: true}, [Validators.required]],
        modelo: [{value: '', disabled: true}, [Validators.required]],
        ano: [{value: '', disabled: true}, [Validators.required]],
        kilometraje: [{value: '', disabled: true}, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        placas: [{value: '', disabled: true}, [Validators.required]],
        noSerie: [{value: '', disabled: true}, [Validators.required]],
        sku: [{value: '', disabled: true}, [Validators.required]],
        descripcion: [{value: '', disabled: true}, [Validators.required]],
        filtro: new FormControl('')
      })
  }

  ngOnInit() {
  }

  async getDetallePP(){
    await this.ppService.getDetallesPlanProtection({empresaId: 0, folio: this.planProtection.folio}).subscribe(
      data => {
        this.planProtectionDetail = data
        this.planProtectionForm = this.fb.group({
          folio: [{value: data.folio, disabled: true}, [Validators.required]],
          empresa: [{value: data.empresaId, disabled: true}, [Validators.required]],
          sucursal: [{value: data.nombreSucursal, disabled: true}, Validators.required],
          ordenVenta: [{value: data.ordenVentaId, disabled: true}, [Validators.required]],
          fechaContratado: [{value: data.fechaVenta, disabled: true}, [Validators.required]],
          fechaVigencia: [{value: data.fechaVigencia, disabled: true}, [Validators.required]],
          nombreCliente: [{value: data.nombreCliente + ' ' + data.apellidos, disabled: true}, [Validators.required]],
          apellidosCliente: [{value: data.apellidos, disabled: true}, [Validators.required]],
          noCliente: [{value: data.clienteId, disabled: true}, [Validators.required]],
          correoCliente: [{value: data.email, disabled: true}, [Validators.required]],
          celularCliente: [{value: data.celular, disabled: true}, [Validators.required]],
          marca: [{value: data.marcaAutoId, disabled: true}, [Validators.required]],
          modelo: [{value: data.modeloAutoId, disabled: true}, [Validators.required]],
          ano: [{value: data.anioAutoId, disabled: true}, [Validators.required]],
          kilometraje: [{value: data.kilometraje, disabled: true}, [Validators.required,]],
          placas: [{value: data.placas, disabled: true}, [Validators.required]],
          noSerie: [{value: data.noSerie, disabled: true}, [Validators.required]],
          sku: [{value: data.sku, disabled: true}, [Validators.required]],
          descripcion: [{value: data.descripcion, disabled: true}, [Validators.required]],
          filtro: new FormControl('')
        })
        this.ppVigente = this.planProtectionDetail.estatus === 'Vigente'
        this.validarEmail(this.planProtectionForm.value.correoCliente)
        // console.log(data.filespaths)
        data.filespaths.forEach(element => {
          // console.log(element)
          if(!element.includes('.pdf')){
            if(!element.includes('img_firma')){
              this.imagenes.push(element)
            }
          }else{
            this.contratoUrl = element
          }
        });

      }
    )
  }

  validateStep(opc){
    this.nextStep()
  }

  showError(message){
    this.dialog.open(ErrorDialogComponent, {
      width: '424px',
      panelClass: 'custom-dialog',
      data: {
        isError: true,
        error: '',
        message
      }
    });
  }

  nextStep(){
    this.step ++
  }

  backStep(){
    this.step --
  }
  async guardarProveedor(){

  }

  enviarArchivo(opc){
    
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }
    
  }

  soloNumeros(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  getImgTitle(img){
    if(img.includes('img_ine')){
      return 'Evidencia Identificación'
    }else if(img.includes('img_tacometro')){
      return 'Evidencia Tacómetro'
    }else if(img.includes('img_placas')){
      return 'Evidencia Placas'
    }else if(img.includes('img_noSerie')){
      return 'Evidencia Número de Serie'
    }else{
      return ''
    }
  }

  abrirGarantia(url){
    const dialogRef = this.dialog.open(VisualizadorPdfComponentDialog, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: window.screen.width < 700 ? '100vw' : '600px',
      height: '90vh',
      maxHeight: '720px',
      data: {
        base64: "",
        blob: false,
        url: "https://twpp-agw.prodx.com.mx/files/prodynamics/2026/03/PP-041-200326-00069/Acuse.pdf"
      }
    });
  }

  abrirContrato(){
    const dialogRef = this.dialog.open(VisualizadorPdfComponentDialog, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: window.screen.width < 700 ? '100vw' : '600px',
      height: '90vh',
      maxHeight: '720px',
      data: {
        base64: "",
        blob: false,
        url: this.contratoUrl
      }
    });
  }

  getImagen(name){
    let index = this.imagenes.findIndex(img => img.includes(name));
    this.abrirImagen(name, index)
  }

  abrirImagen(img: string, i) {
    this.dialog.open(VisualizadorImgDialogComponent, {
      // width: '100vw',
      // height: '100vh',z
      data: { imgs: this.imagenes, indexSelected: i },
      panelClass: 'custom-dialog',
    });
  }

  setOption(opc){
		this.section = opc
		// if(opc === 0){
		// 	this.router.navigate(['home'])
		// }else if(opc === 1){
		// 	this.router.navigate(['recepgencion'])
		// }else if(opc === 2){
		// 	this.router.navigate(['almacenamiento'])
		// }else if(opc === 3){
		// 	this.router.navigate(['picking/erp'])
		// }else if(opc === 4){
		// 	this.router.navigate(['embarque'])
		// }else if(opc === 5){
		// 	this.router.navigate(['compactacion'])
		// }else if(opc === 6){
		// 	this.router.navigate(['auditoria/validaciones'])
		// }
	}

  setColorSection(section){
		if(this.section === section){
			return true
		}else{
			return false
		}
	}
}
